var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"insights"},[_c('am2-insights-section',{attrs:{"enable-see-all-table-route-change":"","campaign-oid":_vm.campaignOid,"insight-type":"campaign","feature-type":"campaign-insights"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }